











































































































































import { Component, Vue } from 'vue-property-decorator';

import Page from '@/componentsV2/molecules/Page/Page.vue';
import Autocomplete from '@/components/molecules/Autocomplete/Autocomplete.vue';
import SelectorAndList from '@/components/organisms/Views/admin/flags/SelectorAndList.vue';
import eventBus from '@/utils/eventBus';
import TextField from '@/components/atoms/TextField/TextField.vue';
import Table from '@/components/molecules/Table/Table.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import { FilledButton } from '@/components/molecules';
import { HeaderList, List } from '@/components/Table/TableModel';

import { EAnalyticsEventsName } from '@/models/analytics-options';

import { treatError } from '@/utils';
import AdminService from '@/api/AdminService';
import { IBusinessResponseListDto } from '@/models/business';
import CloseIcon from '@/components/icons/Close.vue';
import Dropdown from '@/components/molecules/Dropdown/Dropdown.vue';
import { ICustomer } from '@/models/customer';

const ADD_EVENT_STORAGE = '@twism:add-event-storage';

@Component({
  components: {
    Page,
    Autocomplete,
    SelectorAndList,
    TextField,
    Table,
    TableCell,
    TableHeader,
    TableRow,
    FilledButton,
    CloseIcon,
    Dropdown
  }
})
export default class AddEvent extends Vue {
  service: AdminService = new AdminService();

  nameFilter: any = '';
  name: string = '';
  dateTime: string = '';
  loading = false;

  platformOptions: any[] = [
    {
      id: 0,
      label: '[DEV] Twism Dashboard',
      value: 'dashboard'
    },
    {
      id: 1,
      label: '[DEV] Twism App & Widget',
      value: 'app'
    }
  ];
  platform = 'dashboard';

  businesses: IBusinessResponseListDto[] = this.mapBusinesses([]);
  businessesOptions: IBusinessResponseListDto[] = [];

  customers: ICustomer[] = this.mapCustomers([]);
  customersOptions: ICustomer[] = [];

  propertiesList: List = new List([], []);

  listEvents: any = [];

  get nameOptions() {
    const options = Object.values(EAnalyticsEventsName).map(
      (value: string, index: number) => ({
        id: index + 1,
        label: value
      })
    );
    if (this.nameFilter)
      return options.filter(item => item.label.includes(this.nameFilter));
    return options;
  }

  get disabledSubmit() {
    return !this.name || (!this.businesses.length && !this.customers.length);
  }

  addItem(item: any) {
    this.nameFilter = item.label;
    this.name = item.label;
  }

  onSearchName(value: string) {
    this.name = value;
    this.nameFilter = value;
  }

  dateFormat(dateTime: string) {
    if (!dateTime) return '';

    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour12: true,
      hour: '2-digit',
      minute: '2-digit'
    };

    let newDateFormatted = new Date(dateTime).toLocaleString('en', options);
    return newDateFormatted;
  }

  mapBusinesses(businesses: IBusinessResponseListDto[] = []) {
    return businesses.map(business => {
      return {
        label: business.name,
        ...business
      };
    });
  }

  mapCustomers(customers: ICustomer[] = []) {
    return customers.map(customer => {
      return {
        label: `${customer.name} ${customer.lastname} (${customer.mail})`,
        ...customer
      };
    });
  }

  clearAll() {
    this.name = '';
    this.nameFilter = '';
    eventBus.$emit('clearAutocomplete');
    this.dateTime = '';
    this.businesses = [];
    this.customers = [];
    this.propertiesList.list = [];
  }

  initHeader() {
    const header = [
      new HeaderList(`Key`, 'key', '12px 16px'),
      new HeaderList(`Value`, 'value', '12px 16px'),
      new HeaderList(``, 'none', '12px')
    ];
    this.propertiesList.header = header;
  }

  async searchBusinesses(search: string) {
    try {
      const { data } = await this.service.searchBusinesses(search);
      const selectedIds = new Set(this.businesses.map(c => c.id));
      this.businessesOptions = this.mapBusinesses(
        data.items.filter((item: any) => !selectedIds.has(item.id))
      );
    } catch (e) {
      this.businessesOptions = [];
      this.$notification(treatError(e));
    }
  }

  handleDropdownPlatformInput() {
    this.businesses = [];
    this.customers = [];
  }

  async searchCustomers(search: string) {
    try {
      const { data } = await this.service.searchCustomers(search);
      const selectedIds = new Set(this.customers.map(c => c.id));
      this.customersOptions = this.mapCustomers(
        data.items
          .map(({ customer }: any) => customer)
          .filter((item: any) => !selectedIds.has(item.id))
      );
    } catch (e) {
      this.customersOptions = [];
      this.$notification(treatError(e));
    }
  }

  removeDate() {
    this.dateTime = '';
  }

  onNewPropertie() {
    this.propertiesList.list.push({
      key: '',
      value: ''
    });
  }

  removeItem(i: number) {
    this.propertiesList.list = this.propertiesList.list.filter(
      (prop, index) => index !== i
    );
  }

  async onSubmit() {
    this.loading = true;
    try {
      const obj: any = {};

      let date = this.dateTime;

      this.propertiesList.list.forEach(item => {
        obj[item.key] = item.value;
      });
      const data: any = {
        name: this.name,
        metadata: obj,
        userId: this.businesses[0]
          ? this.businesses[0].id
          : this.customers[0].id,
        platform: this.platform
      };
      if (date) data.timestamp = date;
      await this.service.sendManuallyEventToSegment(data);
      const listEvents = [...this.listEvents, data];
      localStorage.setItem(ADD_EVENT_STORAGE, JSON.stringify(listEvents));
      this.listEvents = listEvents;
      this.$notification('Tracking was sent successfully');
    } finally {
      this.loading = false;
    }
  }

  created() {
    this.initHeader();
    const storage = localStorage.getItem(ADD_EVENT_STORAGE);
    if (storage) {
      this.listEvents = JSON.parse(storage);
    }
  }
}
